<template>
  <div id="app">
    <template v-if="!isRegistrationRoute">
      <Header />
    </template>

    <main>
      <router-view />
    </main>

    <template v-if="!isRegistrationRoute">
      <Footer />
    </template>

    <ChatBot v-if="$route.name !== 'chatbot' && !isRegistrationRoute" />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import ChatBot from '@/components/chatbot/ChatBot.vue';

export default {
  name: 'App',
  components: { Header, Footer, ChatBot },
  setup() {
    const route = useRoute();
    const isRegistrationRoute = computed(() =>
      route.path.includes('/register') || route.path.includes('/portal')
    );
    return { isRegistrationRoute };
  }
};
</script>